import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { Locale } from "@/lib/i18n";
import { toLocalizedPath } from "@/lib/i18n";
export default function Logo(t0) {
  const $ = _c(19);
  const {
    size: t1,
    locale: t2
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const locale = t2 === undefined ? "ko" : t2;
  const markSize = size === "lg" ? 56 : size === "sm" ? 32 : 44;
  const textClass = size === "lg" ? "text-3xl" : size === "sm" ? "text-base" : "text-xl";
  let t3;
  if ($[0] !== locale) {
    t3 = toLocalizedPath("/", locale);
    $[0] = locale;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = locale === "ko" ? "\uBAA8\uB450\uC758 \uD14C\uC2A4\uD2B8 \uD648\uC73C\uB85C" : "All Tests home";
  let t5;
  if ($[2] !== markSize) {
    t5 = {
      width: markSize,
      height: markSize
    };
    $[2] = markSize;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = markSize * 0.6;
  const t7 = markSize * 0.6;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <path d="M16 32 l10 10 l22 -22" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" fill="none" />;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== t6 || $[6] !== t7) {
    t9 = <svg viewBox="0 0 64 64" width={t6} height={t7} aria-hidden={true}>{t8}</svg>;
    $[5] = t6;
    $[6] = t7;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t5 || $[9] !== t9) {
    t10 = <span className="grid place-items-center rounded-2xl bg-brand-gradient shadow-pop transition group-hover:scale-[1.03]" style={t5}>{t9}</span>;
    $[8] = t5;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = `font-display ${textClass} text-brand-700`;
  const t12 = locale === "ko" ? "\uBAA8\uB450\uC758 \uD14C\uC2A4\uD2B8" : "All Tests";
  let t13;
  if ($[11] !== t11 || $[12] !== t12) {
    t13 = <span className={t11}>{t12}</span>;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t10 || $[15] !== t13 || $[16] !== t3 || $[17] !== t4) {
    t14 = <Link href={t3} className="group inline-flex items-center gap-2" aria-label={t4}>{t10}{t13}</Link>;
    $[14] = t10;
    $[15] = t13;
    $[16] = t3;
    $[17] = t4;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  return t14;
}